import OrganizationLayout from "@/features/organization/layout/OrganizationLayout";
import OrganizationListPage from "@/features/organization/pages/OrganizationList";
import { OrganizationListFilterCacheProvider } from "@/features/organization/providers/OrganizationListFilterCacheProvider";

const OrganizationList = () => {
  return (
    <OrganizationListFilterCacheProvider>
      <OrganizationLayout>
        <OrganizationListPage />
      </OrganizationLayout>
    </OrganizationListFilterCacheProvider>
  );
};

export default OrganizationList;
